import { React, useState } from 'react';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import PersonAddAlt1RoundedIcon from '@mui/icons-material/PersonAddAlt1Rounded';
import TextField from '@mui/material/TextField';

import { Alerta, PopupDialog } from '../../components/alerta';
import { fetchFlask } from '../../utils/fetchFlask';
import { maskPhone } from '../../utils/maskCpfCnpj';
import '../css/crmCreateLead.css';

const CadastrarLeadCRM = ({ onCancel, onSuccess }) => {
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [telefone, setTelefone] = useState('');
    const [valor, setValor] = useState('');
    const [cupom, setCupom] = useState('');
    const [indicacao, setIndicacao] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');

    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [leadDuplicado, setLeadDuplicado] = useState(null);
    const [openLeadDuplicado, setOpenLeadDuplicado] = useState(false);

    function submitCadastrarCRM (e) {
        e.preventDefault();
        cadastrarLead(false);
    }

    async function cadastrarLead (forcarCadastro) {
        setIsSubmit(true);

        const body = JSON.stringify({
            nome,
            telefone,
            email,
            valor,
            cupom,
            indicacao,
            forcarCadastro
        });

        const response = await fetchFlask('cadastrarLeadCRM', body);
        if (response.status === 'duplicate') {
            setLeadDuplicado({ id: response.lead_id, telefone: response.telefone });
            setOpenLeadDuplicado(true);
            setIsSubmit(false);
            return;
        }

        setMessage(response.message);
        setStatus(response.status);
        setOpenAlerta(true);
        if (response.status === 'success') {
            setNome('');
            setTelefone('');
            setEmail('');
            setValor('');
            setCupom('');
            setIndicacao('');
            onSuccess(response);
        }
        setIsSubmit(false);
    }

    return (
        <div className='crm-create-lead'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />

            <PopupDialog
                titulo='Lead já cadastrado'
                texto={leadDuplicado && `Já existe um lead com o telefone ${leadDuplicado.telefone} (ID ${leadDuplicado.id}). Tem certeza que deseja criar um novo lead?`}
                open={openLeadDuplicado}
                handleClose={() => setOpenLeadDuplicado(false)}
                funcao={() => cadastrarLead(true)}
            />

            <form className='crm-create-lead-card' method='POST' onSubmit={submitCadastrarCRM}>
                <div className='crm-create-lead-card-header'>
                    <div>
                        <p className='crm-create-lead-kicker'>CRM Lead</p>
                        <h2 className='crm-create-lead-title'>Cadastrar lead</h2>
                        <p className='crm-create-lead-copy'>Preencha os dados iniciais para inserir o lead no CRM.</p>
                    </div>

                    <button
                        type='button'
                        className='crm-create-lead-icon-button'
                        aria-label='Fechar cadastro de lead'
                        onClick={onCancel}
                    >
                        <CloseRoundedIcon fontSize='inherit' />
                    </button>
                </div>

                <div className='crm-create-lead-grid'>
                    <div className='crm-create-lead-field is-large'>
                        <TextField
                            className='crm-create-lead-text-field'
                            required
                            label='Nome'
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            fullWidth
                        />
                    </div>
                    <div className='crm-create-lead-field is-medium'>
                        <TextField
                            className='crm-create-lead-text-field'
                            label='Email'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            fullWidth
                        />
                    </div>
                    <div className='crm-create-lead-field is-medium'>
                        <TextField
                            className='crm-create-lead-text-field'
                            required
                            label='Telefone'
                            placeholder='(XX) XXXXXXXX'
                            value={telefone}
                            onChange={(e) => setTelefone(maskPhone(e.target.value))}
                            fullWidth
                        />
                    </div>
                    <div className='crm-create-lead-field is-small'>
                        <TextField
                            className='crm-create-lead-text-field'
                            label='Valor da Conta (R$)'
                            placeholder='XXX,XX'
                            value={valor}
                            onChange={(e) => setValor(e.target.value)}
                            fullWidth
                        />
                    </div>
                    <div className='crm-create-lead-field is-small'>
                        <TextField
                            className='crm-create-lead-text-field'
                            label='Cupom'
                            value={cupom}
                            onChange={(e) => setCupom(e.target.value)}
                            fullWidth
                        />
                    </div>
                    <div className='crm-create-lead-field is-small'>
                        <TextField
                            className='crm-create-lead-text-field'
                            label='Indicação ID'
                            placeholder='id do cliente'
                            value={indicacao}
                            onChange={(e) => setIndicacao(e.target.value)}
                            fullWidth
                        />
                    </div>
                </div>

                <div className='crm-create-lead-actions'>
                    <button
                        type='button'
                        className='crm-create-lead-button crm-create-lead-button-secondary'
                        onClick={onCancel}
                    >
                        Fechar
                    </button>
                    <button
                        type='submit'
                        className='crm-create-lead-button crm-create-lead-button-primary'
                        disabled={isSubmit}
                    >
                        <PersonAddAlt1RoundedIcon fontSize='inherit' />
                        <span>{isSubmit ? 'Cadastrando...' : 'Cadastrar Lead'}</span>
                    </button>
                </div>
            </form>
        </div>
    );
};

export default CadastrarLeadCRM;
